// Kept apart from `notification-picture` so the plain list page (apps/ordo)
// can share it without pulling in the unified inbox's modules.

/**
 * The generic circle's colours, from the V9 design: light is zinc-200 with a
 * zinc-700 bell, dark is zinc-700 with a zinc-200 bell (about 8:1 either way),
 * each with a hairline ring one step out so the circle holds its edge on the
 * popover and page surfaces. `bg-muted` sat a few percent off those surfaces
 * and all but vanished in dark mode. Real `--color-zinc-*` tokens, never the
 * raw `--muted`, which several apps define as a bare HSL triplet.
 */
export const NOTIFICATION_GENERIC_CIRCLE_CLASS =
  'bg-zinc-200 text-zinc-700 ring-1 ring-inset ring-zinc-300 dark:bg-zinc-700 dark:text-zinc-200 dark:ring-zinc-600'
